<template>
    <div>
        <input type="hidden" id="dmaHid" v-model="filter.dma">
        <input type="hidden" id="stateHid" v-model="filter.state">
        <input type="hidden" id="regionFilterName" v-model="filter.region">
        
        <div class="row filterRow d-none d-sm-flex">
            <div class="col-3" v-if="showDepositAmountAndEstEarning">
                <div class="filterHeader">Deposit Amount</div>
                <input class="form-control" id="depositAmount" type="text" placeholder="$25,000" v-model="depositAmount" @blur="setDepositAmount" @keyup.enter="setDepositAmount">
            </div>
            <div class="col-3" v-if="showRegionFilter">
                <div class="filterHeader">Your Region</div>
                <input class="form-control" id="filter_zip" type="search" autocomplete="off" spellcheck="false" placeholder="Enter zip, city, or state">
                <transition name="fade-with-background" :duration="{ enter: 2000, leave: 0 }" appear>
                    <label id="filter_region" v-bind:key="filter.region" class="dma">{{(filter.region) ? filter.region : 'Nationwide Only'}}</label>
                </transition>
            </div>
            <div class="col-3" v-if="showAvailabilityFilter">
                <div class="filterHeader">Availability</div>
                <select class="form-control" name="availability" v-model="filter.availability">
                    <option value="branch">Local Branches only</option>
                    <option value="online">Online only</option>
                    <option value="branchAndOnline">Branches & Online</option>
                </select>
            </div>
            <div class="col-3" v-if="showInstitutionFilter">
                <div class="filterHeader">Institution Type</div>
                <select class="form-control" name="institution" v-model="filter.institutionType">
                    <option value="bank">Banks</option>
                    <option value="credit">Credit Unions</option>
                    <option value="bankAndCredit">Banks & Credit Unions</option>
                </select>
                <div class="linkSection">
                    <a class="linkText" v-on:click="show = !show" v-if="filter.institutionType === 'credit' || filter.institutionType === 'bankAndCredit'">{{show ? 'Collapse' : 'Expand'}} Credit Union Options</a>
                </div>
            </div>
        </div>
        <transition name="fade">
            <div class="cuIndustries animated fadeIn d-none d-sm-block" v-if="show && (filter.institutionType === 'credit' || filter.institutionType === 'bankAndCredit')">
                <span class="filterHeader">Include Additional Credit Unions</span> <span class="linkSection">
                    <a class="linkText" v-on:click="selectAllUnionOptions">({{isAllUnionOption ? 'Include' : 'Exclude'}} All Affiliations)</a></span>
                <p>By default, only credit unions with easy membership requirements are included in the search results. To include additional credit unions, select the industries below that you or your <b>immediate family</b> members currently or previously worked in.</p>
                <div class="row filterRow">
                    <div v-for="unionOption in unionOptions"
                         v-bind:key="unionOption.value"
                         class="col-4 col-md-3">
                        <input type="checkbox" v-bind:id="unionOption.value" v-bind:name="unionOption.value" v-bind:value="unionOption.value" v-model="filter.selectedUnionOptions">
                        <label v-bind:for="unionOption.value">{{unionOption.displayText}}</label>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script lang="ts">
import Vue, { defineComponent } from 'vue'
export default defineComponent({
    components: {},
    name: "RateTableFilter",
    data: function() {
        return {
            depositAmount: "",
            show: false,
            isAllUnionOption: true,
            unionOptions: [
                    { value:"chemical", displayText:"Chemical / Pharma" },
                    { value:"financial", displayText: "Financial Services" },
                    { value:"manufacturing", displayText: "Manufacturing" },
                    { value:"transportation", displayText: "Transportation / Aero" },
                    { value:"edu", displayText: "Education" },
                    { value:"gov", displayText: "Gov / Military" },
                    { value:"religion", displayText: "Religion" },
                    { value:"telecom", displayText: "Telecom" },
                    { value:"energy", displayText: "Energy / Utility" },
                    { value:"health", displayText: "Healthcare" },
                    { value:"retail", displayText: "Retail" },
                    { value:"entertainment", displayText: "Entertainment" }
                ]
        };
    },
    props:{
        filter: Object,
        isWp: Boolean,
        showDepositAmountAndEstEarning: Boolean,
        showRegionFilter: Boolean,
        showAvailabilityFilter: Boolean,
        showInstitutionFilter: Boolean
    },
    mounted: function() {
        if(this.isWp){
            this.depositAmount = this.filter.depositAmount.toLocaleString();
            this.depositAmount = this.formatDepositAmount(this.depositAmount);
        }
    },
    methods: {
        setDepositAmount() {
            this.depositAmount = this.formatDepositAmount(this.depositAmount);
            this.filter.depositAmount = this.depositAmount;
        },
        formatDepositAmount(amount : string) {
            let depositAmount = amount.replace(/\D/g,'');

            if (depositAmount) {
                let depositAmountInt = parseInt(depositAmount);
                depositAmount = depositAmountInt.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 });
            } else {
                depositAmount = "";
            }
            return depositAmount;
        },
        selectAllUnionOptions() {
            if(this.isAllUnionOption){
                this.filter.selectedUnionOptions = this.unionOptions.map(x => x.value);
            }
            else{
                this.filter.selectedUnionOptions = [];
            }
            this.isAllUnionOption = !this.isAllUnionOption;
        }
    }
});
</script>
<style lang="scss" scoped>
.cuIndustries{
    margin-top:20px;
    label[for]{
        margin-bottom:0;
    }
}
</style>